import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import type { SalesDraftDetailOutput, SalesDraftOrder } from '../../../server/types/drafts-types.ts';
import { api } from '../../../utils/api.ts';

export type UseDraftContextOptions = {
    refetchOnMount?: boolean;
};

export type UseDraftContextHook = {
    draftId: string | undefined;
    draft: SalesDraftOrder | undefined;
    isLoading: boolean;
    setDraft: (data: SalesDraftDetailOutput) => void;
};

export function useDraftContext({ refetchOnMount }: UseDraftContextOptions = {}): UseDraftContextHook {
    const apiUtils = api.useUtils();
    const { draft_id } = useParams<{ draft_id: string }>();

    const { data: draft, isLoading } = api.platoUser.query.salesDraft.getSalesDraft.byId.useQuery(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- protected by enabled prop
        { draftOrderId: draft_id! },
        {
            enabled: !!draft_id,
            refetchOnMount,
            select: (data) => data.draft_order,
        },
    );

    const setDraft = useCallback(
        (data: SalesDraftDetailOutput) => {
            apiUtils.platoUser.query.salesDraft.getSalesDraft.byId.setData(
                { draftOrderId: data.draft_order.draft_order_id },
                data,
            );
        },
        [apiUtils],
    );

    return {
        draftId: draft_id,
        draft,
        isLoading,
        setDraft,
    };
}
